export const useComposable = () => {
    //* 获取I18n
    const i18n = useI18n();

    //* 响应式变量
    const refs = {
        key: ref<number>(0),
    };

    //* 配置项
    const options = [
        {
            name: i18n.t("MutationAnalysisTools"),
            children: [
                {
                    tag: i18n.t("AITool"),
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/rna-splicer.png",
                    name: i18n.t("RNASplicer"),
                    label: "RNA Splicer",
                    route: { name: "RnaSplicer" },
                    descript: i18n.t("RNASplicerDescribe"),
                },
                {
                    tag: i18n.t("AITool"),
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/pathogenicity.png",
                    name: i18n.t("VPP"),
                    label: "Pathogenicity Predictor",
                    route: { name: "Pathogenicity" },
                    descript: i18n.t("PathoPredictDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/VariantViewer.png",
                    name: i18n.t("MutationViewer"),
                    label: "Mutation Direct",
                    route: { name: "BioVariant" },
                    descript: i18n.t("MutationViewerDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/SNPVisualization.png",
                    name: i18n.t("SNPVisualization"),
                    label: "SNP Viewer",
                    route: { name: "DBSNP" },
                    descript: i18n.t("SNPVisualizationDescribe"),
                },
                {
                    tag: i18n.t("AITool"),
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/MousePhenoPredict.png",
                    name: i18n.t("MousePhenoPredict"),
                    label: "Mouse Pheno Predictor",
                    route: { name: "MousePhenoPredict" },
                    descript: i18n.t("MousePhenoPredictDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/aso.png",
                    name: i18n.t("ASO"),
                    label: "ASO Designer",
                    route: { name: "ASO" },
                    descript: i18n.t("ASODescribe"),
                },
            ],
        },
        {
            name: i18n.t("SequenceAnalysisTools"),
            children: [
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/sequence-alignment.png",
                    name: i18n.t("SequenceAlignment"),
                    label: "Sequence Alignment",
                    route: { name: "SequenceAlignment" },
                    descript: i18n.t("SequenceAlignmentDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/sequence-viewer.png",
                    name: i18n.t("SequenceViewer"),
                    label: "Sequence Viewer",
                    route: { name: "BioSequence" },
                    descript: i18n.t("SequenceViewerDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/AASymbolConverter.png",
                    name: i18n.t("AAAbbreviationConverter"),
                    label: "Amino Acid Abbreviation Converter",
                    route: { name: "AbbreviationConverter" },
                    descript: i18n.t("AAAbbreviationConverterDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/Translation.png",
                    name: i18n.t("SequenceProcessor"),
                    label: "Sequence Processor",
                    route: { name: "SequenceProcessor" },
                    descript: i18n.t("SequenceProcessorToolDescript"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/BLAT.png",
                    name: i18n.t("BLAT"),
                    label: "BLAT",
                    route: { name: "BLAT" },
                    descript: i18n.t("BLATDescribe"),
                },
            ],
        },
        {
            name: i18n.t("ComparisonTools"),
            children: [
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/GeneticComparison.png",
                    name: i18n.t("GeneticComparison"),
                    label: "Gene Comparison",
                    route: { name: "GeneticComparison" },
                    descript: i18n.t("GeneticComparisonDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/DiseasesComparison.png",
                    name: i18n.t("DiseasesComparison"),
                    label: "Disease Comparison",
                    route: { name: "DiseasesComparison" },
                    descript: i18n.t("DiseasesComparisonDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/ModelComparison.png",
                    name: i18n.t("ModelComparison"),
                    label: "Model Comparison",
                    route: { name: "ModelComparison" },
                    descript: i18n.t("ModelComparisonDescribe"),
                },
            ],
        },
        {
            name: i18n.t("OtherTools"),
            children: [
                {
                    tag: i18n.t("AITool"),
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/AIAgent.png",
                    name: i18n.t("AIAgent"),
                    label: "AI Assistant",
                    route: { name: "Chatagent" },
                    descript: i18n.t("AIAgentDescribe"),
                },
                {
                    tag: i18n.t("AITool"),
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/mth.png",
                    name: i18n.t("MTH"),
                    label: "Homolog Predictor",
                    route: { name: "MTH" },
                    descript: i18n.t("MTHDesc"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/pathway.png",
                    name: i18n.t("PathwayAnalysis"),
                    label: "Pathway Enrichment Analysis",
                    route: { name: "SignalPath" },
                    descript: i18n.t("PathwayAnalysisDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/Ensembl-NCBI.png",
                    name: i18n.t("EnsemblNCBI"),
                    route: { name: "TransformID" },
                    label: "Ensembl-NCBI Converter",
                    descript: i18n.t("EnsemblNCBIDescribe"),
                },
                {
                    tag: i18n.t("AITool"),
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/SingleCellAtlas.png",
                    name: i18n.t("SingleCellAtlas"),
                    label: "Gene Expression Database",
                    route: "/sca",
                    descript: i18n.t("SingleCellAtlasDescribe"),
                },
                {
                    tag: "",
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/CancerBiomarkersLibrary.png",
                    name: i18n.t("CancerBiomarkersLibrary"),
                    label: "Cancer Target Database",
                    route: { name: "CBL" },
                    descript: i18n.t("CancerBiomarkersLibraryDescribe"),
                },
                {
                    tag: i18n.t("AITool"),
                    img: "https://rdgta.cdn.cyagen.com/rddc/images/tool/DG-Prediction.png",
                    name: i18n.t("DGPrediction"),
                    label: "Affinity Predictor",
                    route: { name: "DGPrediction" },
                    descript: i18n.t("DGPredictionDesc1"),
                },
            ],
        },
    ];

    const methods = {
        navigate: (index: number) => {
            const node = document.querySelectorAll(".tools-container")[index] as HTMLElement;

            //* 触发滚动
            if (node) scrollTo({ top: (node.offsetTop || 0) - 20, behavior: "smooth" });
        },
        handler: () => {
            //* 通过页面滚动距离计算当前导航索引
            document.querySelectorAll(".tools-container")?.forEach((value, index) => {
                const rect = value.getBoundingClientRect();
                if (rect.top >= 0 && rect.top <= innerHeight * 0.3 && rect.bottom >= 0) {
                    //* 索引更新
                    refs.key.value = index;
                }
            });
        },
    };

    return { refs, options, methods };
};
